import { create } from "zustand";
import { ProposalState, ProposalStateValues } from "./types";

const initialValues: ProposalStateValues = {
  proposalData: undefined,
  isFidelityProposal: false,
  isReviewEdit: false,
  selectedProduct: null,
  selectedFinancialService: null,
  selectedServicePoint: null
};

export const useProposalStore = create<ProposalState>()((set, get) => ({
  ...initialValues,
  setProposalData: (data) => {
    set({ proposalData: data });
  },
  updateProposalData: (data) => {
    const current = get();
    if (current.proposalData) {
      const updated = {
        ...current.proposalData,
        ...data
      };
      set({
        proposalData: updated
      });
    } else {
      set({ proposalData: data });
    }
  },
  setIsFidelityProposal: (value) => {
    set({ isFidelityProposal: value });
  },
  setIsReviewEdit: (value) => {
    set({ isReviewEdit: value });
  },
  setSelectedProduct: (product) => {
    set({ selectedProduct: product });
  },
  setSelectedFinancialService: (service) => {
    set({ selectedFinancialService: service });
  },
  setSelectedServicePoint: (point) => {
    set({ selectedServicePoint: point });
  },
  resetProposalStore: () => {
    set(initialValues);
  }
}));
